import { axios } from '@/utils/request'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'

// 商品库列表/id详情(登录)
export function getBasicProduct(params, notLogin, id) {
  let url = '/distribution/basicProduct'
  if (!Vue.ls.get(ACCESS_TOKEN)) {
    url = '/frontend/basicProduct'
  }
  return axios({
    url: id || +id === 0 ? `${url}/${id}` : url,
    method: 'GET',
    params
  })
}

// 梯度价(登录)
export function getPurchasePrice(params, notLogin, id) {
  let url = '/distribution/basicProduct/getPurchaseRule/'
  if (!Vue.ls.get(ACCESS_TOKEN)) {
    url = '/frontend/basicProduct/getPurchaseRule/'
  }
  return axios({
    url: url + id,
    method: 'GET',
    params
  })
}

// 获取所有标签
export function getStockSkuCategory(notLogin, params) {
  let url = '/distribution/stockSkuCategory'
  if (notLogin) {
    url = '/api/stockSkuCategory'
  }
  return axios({
    url: url,
    method: 'GET',
    params
  })
}

// 查看当前商品运费(登录)
export function getLogisticsPrice(params, notLogin, id) {
  let url = '/distribution/basicProduct/logistics/'
  if (notLogin) {
    url = '/frontend/basicProduct/logistics/'
  }
  return axios({
    url: url + id,
    method: 'GET',
    params
  })
}

// 查看商品价格(登录)
export function getGoodsPrice(params, notLogin, id) {
  let url = '/distribution/basicProduct/getPurchasePrice/'
  if (notLogin) {
    url = '/frontend/basicProduct/getPurchasePrice/'
  }
  return axios({
    url: url + id,
    method: 'GET',
    params
  })
}

// 批量更改分类
export function changeClass(data) {
  return axios({
    url: '/distribution/basicProduct/categorys',
    method: 'POST',
    data
  })
}

// 用户商品分类列表
export function getProductCategory(params) {
  return axios({
    url: '/distribution/userBasicProductCategory',
    method: 'GET',
    params
  })
}

// 添加用户商品分类
export function addProductCategory(data) {
  return axios({
    url: '/distribution/userBasicProductCategory',
    method: 'POST',
    data
  })
}
// 更改用户商品分类
export function putProductCategory(data) {
  const { parent_id } = data
  delete data.parent_id
  return axios({
    url: '/distribution/userBasicProductCategory/' + parent_id,
    method: 'PUT',
    data
  })
}
// 删除用户商品分类
export function deleteProductCategory(id) {
  return axios({
    url: '/distribution/userBasicProductCategory/' + id,
    method: 'DELETE'
  })
}
// 更新分类排序
export function updateSort(data) {
  return axios({
    url: '/distribution/userBasicProductCategory/updateSort',
    method: 'POST',
    data
  })
}

// 生产工艺
export function getTechnology() {
  return axios({
    url: '/api/product/searchField/product_technology',
    method: 'GET'
  })
}
// 尺码属性
export function getSizeAttribute() {
  return axios({
    url: '/api/product/searchField/size_attribute',
    method: 'GET'
  })
}
// 季节属性
export function getSeasonalAttribute() {
  return axios({
    url: '/api/product/searchField/seasonal_attribute',
    method: 'GET'
  })
}
// 产品材质
export function getMaterial() {
  return axios({
    url: '/api/product/searchField/product_material',
    method: 'GET'
  })
}
// 适用人群
export function getGender() {
  return axios({
    url: '/api/product/searchField/apply_gender',
    method: 'GET'
  })
}
// 专题活动
export function getBasicProductBanner() {
  return axios({
    url: '/frontend/basicProduct/basicProductBanner',
    method: 'GET'
  })
}
// 专题详情
export function viewAdSpecial(id) {
  return axios({
    url: '/frontend/basicProduct/adSpecial/' + id,
    method: 'GET'
  })
}
// 获取热门搜索
export function recommenderWords() {
  return axios({
    url: '/frontend/basicProduct/recommenderWords',
    method: 'GET'
  })
}
// 获分类tree  ID
export function getParents(params) {
  return axios({
    url: '/frontend/stockSkuCategory/parents',
    method: 'GET',
    params
  })
}
// 发货国家
export function getSkuCountry() {
  return axios({
    url: '/api/basicProduct/getSkuCountry',
    method: 'GET'
  })
}
// 专题数量
export function getRecommend() {
  return axios({
    url: '/distribution/basicProduct/getRecommend',
    method: 'GET'
  })
}
